import { Link } from "react-router-dom";
import { ArrowRight, Mail, MapPin } from "lucide-react";
import { PageHero } from "../components/site/Blocks";
import { ContactForm } from "../components/forms/ContactForm";

const QUICK = [
  ["Arranging in-home care", "/in-home-care#care-questionnaire", "contact-quick-care"],
  ["Looking for housing", "/housing#housing-questionnaire", "contact-quick-housing"],
  ["Applying to join our team", "/careers#caregiver-application", "contact-quick-careers"],
  ["Exploring a partnership", "/partner-with-us#partner-inquiry", "contact-quick-partner"],
];

export default function Contact() {
  return (
    <>
      <PageHero eyebrow="Contact" title="We would be glad to hear from you." testId="contact-hero">
        <p>Send us a message and a member of our team will respond. For the quickest response to a specific request, use one of the dedicated forms below.</p>
      </PageHero>
      <section className="container-site py-16 sm:py-20 grid lg:grid-cols-12 gap-10">
        <aside className="lg:col-span-4 space-y-6">
          <div className="card-warm p-6 space-y-4">
            <h2 className="font-display text-xl font-semibold">Dedicated forms</h2>
            {QUICK.map(([t, to, id]) => (
              <Link key={id} to={to} className="flex items-center justify-between rounded-xl border border-[#E5E0D8] px-4 py-3 text-sm font-medium hover:border-[#1E3A2B] transition-colors" data-testid={id}>
                {t}<ArrowRight className="h-4 w-4 text-[#C86D51]" />
              </Link>
            ))}
          </div>
          <div className="card-warm p-6 space-y-4 text-sm">
            <p className="flex items-start gap-3"><Mail className="h-4 w-4 mt-0.5 text-[#C86D51]" />
              <a href="mailto:admin@FriendshipPenCare.com" className="underline" data-testid="contact-email-link">admin@FriendshipPenCare.com</a>
            </p>
            <p className="flex items-start gap-3"><MapPin className="h-4 w-4 mt-0.5 text-[#C86D51]" />Serving the Greater Toronto Area, Ontario, Canada</p>
          </div>
        </aside>
        <div className="lg:col-span-8"><ContactForm /></div>
      </section>
    </>
  );
}
